import script from "./temp3.vue?vue&type=script&setup=true&lang=js"
export * from "./temp3.vue?vue&type=script&setup=true&lang=js"

import "./temp3.vue?vue&type=style&index=0&id=411bf193&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411bf193"]])

export default __exports__